import { gql } from 'graphql.macro';

export const lookupCrediflowPartyTemplate = gql`
    query lookupCrediflowParty($organizationNumber: String!, $countryCode: CrediflowSupportedCountry!) {
        lookupCrediflowParty(organizationNumber: $organizationNumber, countryCode: $countryCode) {
            totalResources
            parties {
                id
                name
                contactName
                countryCode
                cin
                email
                address1
                address2
                zipCode
                city
                phone
                fax
                gln
                vat
                bankgiro
                plusGiro
                iban
                bic
                services {
                    serviceTypeId
                    compliance
                    instructions
                }
            }
        }
    }
`;
